import { useEffect } from "react";
import Navbar from "../components/Navbar";
import { useCookie3 } from "../lib/analytics/provider";
import NewSlide1 from "../components/Slides/NewSlide1";
import NewSlide3 from "../components/Slides/NewSlide3";
import NewSlide2 from "../components/Slides/NewSlide2";
import NewSlide4 from "../components/Slides/NewSlide4";
import NewSlide7 from "../components/Slides/NewSlide7";

export const HomePage = () => {
  const cookie3 = useCookie3();

  useEffect(() => {
    cookie3.trackPageView();
  }, []);

  return (
    <div className="bg-landing-Linear overflow-x-hidden h-screen overflow-y-scroll xl:snap-y xl:snap-mandatory">
      <Navbar />
      <NewSlide1 />
      <NewSlide2 />
      <NewSlide3 />
      <NewSlide4 />
      <NewSlide7 />
    </div>
  );
};
